import Icon from '../components/Icon.vue'

Icon.register({
  gopuram: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 352H480V240C480 231.2 472.8 224 464 224H448V144C448 135.2 440.8 128 432 128H416V16C416 7.2 408.8 0 400 0S384 7.2 384 16V32H320V16C320 7.2 312.8 0 304 0S288 7.2 288 16V32H224V16C224 7.2 216.8 0 208 0S192 7.2 192 16V32H128V16C128 7.2 120.8 0 112 0S96 7.2 96 16V128H80C71.2 128 64 135.2 64 144V224H48C39.2 224 32 231.2 32 240V352H16C7.2 352 0 359.2 0 368V496C0 504.8 7.2 512 16 512H96V352H128V224H160V128H192V224H160V352H128V512H208V432C208 423.2 215.2 416 224 416H288C296.8 416 304 423.2 304 432V512H384V352H352V224H320V128H352V224H384V352H416V512H496C504.8 512 512 504.8 512 496V368C512 359.2 504.8 352 496 352zM224 352V288C224 279.2 231.2 272 240 272H272C280.8 272 288 279.2 288 288V352H224zM232 224V176C232 167.2 239.2 160 248 160H264C272.8 160 280 167.2 280 176V224H232z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gopuram.js
// module id = ytL/
// module chunks = 144